/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {CreateProjectRequest, ProjectDetailResponse, ProjectListItem, UpdateProjectRequest} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Lists the current user's projects
 */
export type listMyProjectsResponse200 = {
  data: ProjectListItem[]
  status: 200
}

export type listMyProjectsResponseSuccess = listMyProjectsResponse200 & {
  headers: Headers
}
export type listMyProjectsResponse = listMyProjectsResponseSuccess

export const getListMyProjectsUrl = () => {
  return `/my-projects`
}

export const listMyProjects = async (options?: RequestInit): Promise<listMyProjectsResponse> => {
  return customFetch<listMyProjectsResponse>(getListMyProjectsUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Creates a new project for the current user
 */
export type createMyProjectResponse200 = {
  data: ProjectDetailResponse
  status: 200
}

export type createMyProjectResponseSuccess = createMyProjectResponse200 & {
  headers: Headers
}
export type createMyProjectResponse = createMyProjectResponseSuccess

export const getCreateMyProjectUrl = () => {
  return `/my-projects`
}

export const createMyProject = async (
  createProjectRequest: CreateProjectRequest,
  options?: RequestInit,
): Promise<createMyProjectResponse> => {
  return customFetch<createMyProjectResponse>(getCreateMyProjectUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(createProjectRequest),
  })
}

/**
 * Returns a single project belonging to the current user
 */
export type getMyProjectResponse200 = {
  data: ProjectDetailResponse
  status: 200
}

export type getMyProjectResponseSuccess = getMyProjectResponse200 & {
  headers: Headers
}
export type getMyProjectResponse = getMyProjectResponseSuccess

export const getGetMyProjectUrl = (id: string) => {
  return `/my-projects/${id}`
}

export const getMyProject = async (id: string, options?: RequestInit): Promise<getMyProjectResponse> => {
  return customFetch<getMyProjectResponse>(getGetMyProjectUrl(id), {
    ...options,
    method: 'GET',
  })
}

/**
 * Updates an existing project belonging to the current user
 */
export type updateMyProjectResponse200 = {
  data: ProjectDetailResponse
  status: 200
}

export type updateMyProjectResponseSuccess = updateMyProjectResponse200 & {
  headers: Headers
}
export type updateMyProjectResponse = updateMyProjectResponseSuccess

export const getUpdateMyProjectUrl = (id: string) => {
  return `/my-projects/${id}`
}

export const updateMyProject = async (
  id: string,
  updateProjectRequest: UpdateProjectRequest,
  options?: RequestInit,
): Promise<updateMyProjectResponse> => {
  return customFetch<updateMyProjectResponse>(getUpdateMyProjectUrl(id), {
    ...options,
    method: 'PUT',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(updateProjectRequest),
  })
}

/**
 * Deletes a project belonging to the current user
 */
export type deleteMyProjectResponse204 = {
  data: void
  status: 204
}

export type deleteMyProjectResponseSuccess = deleteMyProjectResponse204 & {
  headers: Headers
}
export type deleteMyProjectResponse = deleteMyProjectResponseSuccess

export const getDeleteMyProjectUrl = (id: string) => {
  return `/my-projects/${id}`
}

export const deleteMyProject = async (id: string, options?: RequestInit): Promise<deleteMyProjectResponse> => {
  return customFetch<deleteMyProjectResponse>(getDeleteMyProjectUrl(id), {
    ...options,
    method: 'DELETE',
  })
}
